import invoiceCosts from './invoice-extract-config.json';
import DataDocExCosts from './doc-data-extract-config.json';
import EmotionAnalysisCosts from './emotion-analysis-text-config.json';
import { Console } from '../../../services/platform-api';

const GetCostEstimates = (id) => {
  if (id === 1) return invoiceCosts;
  if (id === 4) return DataDocExCosts;
  if (id === 6 || id === 7) return EmotionAnalysisCosts; // 7 is doc summarisation, no pricing yet
  return invoiceCosts;
};
export default GetCostEstimates;
